import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {BubbleList, Button, XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', [
            _$cc(Button, {
                'ev-click': this.startStreaming,
                'children': '开始流式输出'
            }),
            _$cc(Button, {
                'ev-click': this.reset,
                'children': '重置'
            })
        ], 4, 'bubble-list-demo-streaming-actions'),
        _$cc(BubbleList, {
            'className': 'bubble-list-demo-streaming-list',
            'items': this.get('items'),
            'roles': this.get('roles'),
            'ev-autoScrollChange': this.handleAutoScrollChange,
            'ev-typingComplete': this.handleTypingComplete,
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['content'] = function($super, scope) {
                            return (
                                (scope.mergedItem.isMarkdown) ?
                                    _$cc(XMarkdown, {
                                        'content': scope.mergedItem.content,
                                        'streaming': scope.mergedItem.streaming,
                                        'loading': scope.mergedItem.loading,
                                        'typing': this.getTypingOptions(scope.mergedItem)
                                    }) :
                                    _$ce(2, 'span', scope.mergedItem.content, 0)
                            );
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['extra'] = function($super, scope) {
                            return (
                                (scope.mergedItem.role === 'ai') ?
                                    _$ce(2, 'div', (
                                        (scope.item.completed) ?
                                            _$ce(2, 'span', '已完成', 16) :
                                            _$ce(2, 'span', '生成中...', 16)
                                    ), 2, 'bubble-list-demo-streaming-extra') :
                                    undefined
                            );
                        }),
                        (__$blocks['extra'] = function($super, data) {
                            var block = $blocks['extra'];
                            var callBlock = function() {
                                return _$blocks['extra'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'bubble-list-demo-streaming');
};